import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ShiftIndicatorComponent } from "ng/src/app/shifts/indicator/shift-indicator.component";
import { ButtonModule } from "primeng/button";
import { ShiftSignOnComponent } from "ng/src/app/shifts/sign-on/shift-sign-on.component";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { FormsModule } from "@angular/forms";
import { CalendarModule } from "primeng/calendar";
import { DropdownModule } from "primeng/dropdown";
import { DividerModule } from "primeng/divider";
import { NoteAcksComponent } from "ng/src/app/shifts/note-acks/note-acks.component";
import { CarouselModule } from "primeng/carousel";
import { SharedModule } from "ng/src/app/shared/shared.module";
import { CardModule } from "primeng/card";
import { MessagesModule } from "primeng/messages";
import { DialogModule } from "primeng/dialog";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { TooltipModule } from "primeng/tooltip";
import { MessageModule } from "primeng/message";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { SingleShiftSignOnComponent } from './single-shift-sign-on/single-shift-sign-on.component';

@NgModule({
	declarations: [
		ShiftIndicatorComponent,
		ShiftSignOnComponent,
		NoteAcksComponent,
    SingleShiftSignOnComponent
	],
	exports: [
		ShiftIndicatorComponent
	],
	imports: [
		CommonModule,
		ButtonModule,
		DynamicDialogModule,
		FormsModule,
		CalendarModule,
		DropdownModule,
		DividerModule,
		CarouselModule,
		SharedModule,
		CardModule,
		MessagesModule,
		DialogModule,
		ConfirmPopupModule,
		TooltipModule,
		MessageModule,
		ConfirmDialogModule,
		OverlayPanelModule
	]
})
export class ShiftModule {}